/* eslint-disable */
import Vue from 'vue';
import popupModalTemplate from './src/popupModal';

const popupModalConstructor = Vue.extend(popupModalTemplate);

let instance;
let instances = [];
let seed = 1;

const popupModal = (options = {}) => {
  const OnClose = options.onClose;
  seed += 0;
  const id = `popupModal_${seed}`;

  options.onClose = () => {
    popupModal.close(id, OnClose);
  };

  instance = new popupModalConstructor({
    data: options,
  });

  instance.id = id;
  instance.vm = instance.$mount();
  document.getElementById("zeuspayChat").appendChild(instance.vm.$el);
  instance.vm.visible = true;
  instance.dom = instance.vm.$el;
  instances.push(instance);
  return instance.vm;
};

popupModal.close = (id, OnClose) => {
  for (let i = 0, len = instances.length; i < len; i++) {
    if (id === instances[i].id) {
      if (typeof OnClose === 'function') {
        OnClose(instances[i]);
      }
      instances.splice(i, 1);
      break;
    }
  }
};

export {
  popupModal,
};



// WEBPACK FOOTER //
// ./src/components/oneToOne/popupModal/index.js